var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPageUpButtoninline = function SvgPageUpButtoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 10.971l7.97-7.97 7.97 7.97"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M8.97 4.5L9 17"
  }))));
};
export default SvgPageUpButtoninline;